module.exports = __webpack_public_path__ + "media/images/home/usecase-autonomous-d3a2ef1f2393238d79a527f396274783.jpg";